import type { Tooltip, TooltipFormatterContextObject } from 'highcharts/highcharts';
import type { ReactNode } from 'react';
import type { Currency } from '../../../types';
import { Box, Flex } from '../../Core';
import { ChartTooltipValue } from './ChartTooltipValue';
import { ChartTooltipWrapper } from './styles';
import type { ChartTooltipValueType, UseChartTooltipProps } from './types';

/**
 * Box plot tooltip popover, for Highcharts
 */
export type BoxPlotTooltipProps = {
  data: TooltipFormatterContextObject;
  homeCurrency?: Currency | undefined;
  valueType: ChartTooltipValueType;
  title?: ReactNode;
  tooltip?: Tooltip;
} & Pick<UseChartTooltipProps, 'dateFormatter' | 'resolution'>;

export function BoxPlotTooltip({ data, homeCurrency, valueType, title }: BoxPlotTooltipProps) {
  const point = data.point;
  const series = data.series;
  if (data) {
    return (
      <ChartTooltipWrapper gap="spacing4" display="flex" flexDirection="column">
        <Box mb="spacing4" color="colorTextImportant">
          {title ?? point.name ?? series.name}
        </Box>
        <Flex gap="spacing4">
          <Box flex="1">5th</Box>
          <ChartTooltipValue data={point.low} valueType={valueType} currency={homeCurrency} />
        </Flex>
        <Flex gap="spacing4">
          <Box flex="1">25th</Box>
          <ChartTooltipValue data={point.q1} valueType={valueType} currency={homeCurrency} />
        </Flex>
        <Flex gap="spacing4">
          <Box flex="1">Median</Box>
          <ChartTooltipValue data={point.median} valueType={valueType} currency={homeCurrency} />
        </Flex>
        <Flex gap="spacing4">
          <Box flex="1">75th</Box>
          <ChartTooltipValue data={point.q3} valueType={valueType} currency={homeCurrency} />
        </Flex>
        <Flex gap="spacing4">
          <Box flex="1">95th</Box>
          <ChartTooltipValue data={point.high} valueType={valueType} currency={homeCurrency} />
        </Flex>
      </ChartTooltipWrapper>
    );
  }
  return <></>;
}
